import {call, put, takeLatest} from 'redux-saga/effects';
import {GET_HISTORY, GET_HISTORY_SUCCESS} from './history.types';
import {historyService} from './history.service';
import {httpRequestsOnLoadActions} from '../http_requests_on_load';
import {httpRequestsOnErrorsActions} from '../http_requests_on_errors';

function* getHistory({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(historyService.getHistoryService, payload?.params);
        yield put({
            type: GET_HISTORY_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

export const watchHistory = function* watchHistorySaga() {
    yield takeLatest(GET_HISTORY, getHistory);
};
